'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var pdfObject = require("pdfobject");
ngModule.directive("pdfViewer", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      url: "<",
      height: "<",
      page: "<",
      /**
       * ne fonctionne pas avec le embed de pdfObject. Il faudrait tester avec jspdf
       */
      highlightText: "<"
    },
    template: "\n            <div class=\"tl-pdf-viewer\"> \n               <div class=\"pdf-container\"></div> \n            </div>",
    link: function link($scope, $element, $attrs, ctrl) {
      if (pdfObject.supportsPDFs) {
        $scope.$watchGroup(['url', 'page', 'highlightText'], function (newValues) {
          var newUrl = newValues[0];
          var newPage = newValues[1];
          var newText = newValues[2];
          if (newUrl) {
            ctrl.refreshDocument(newUrl, newPage, newText);
          }
        });
      } else {
        $element.find(".pdf-container").text("Votre navigateur ne supporte pas la lecture de fichiers pdf. " + "Veuillez télécharger le lecteur Acrobat reader.");
      }
      $scope.$watch("height", function (height) {
        if (height != null) {
          ctrl.setHeight(height);
        }
      });
      $element.on("mouseenter", function () {
        $scope.$emit('pdfViewer::mouseenter');
      });
    },
    controller: function controller($element) {
      var ctrl = this;
      ctrl.refreshDocument = function (baseUrl, page, textToHighlight) {
        if (!baseUrl) {
          return;
        }
        var container = $element.find(".pdf-container");
        container.empty();

        // On utilise l'objet d'options de pdfObject, avec la bonne structure.
        var options = {
          // 'page' est une option de premier niveau.
          page: page || 1
        };

        // 'search' et les autres paramètres doivent aller dans l'objet 'pdfOpenParams'.
        if (textToHighlight) {
          // On ne met PAS les guillemets nous-mêmes. On passe le texte brut.
          // pdfObject s'occupera de formater correctement le paramètre.
          options.pdfOpenParams = {
            search: textToHighlight
          };
        }

        // On laisse pdfObject construire l'URL finale.
        pdfObject.embed(baseUrl, container, options);
      };
      ctrl.setHeight = function (height) {
        $element.css("height", "".concat(height, "px"));
        $element.find(".pdf-container").css("height", "".concat(height, "px"));
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/pdfViewer.js
// module id = 2981
// module chunks = 13